import watch from 'redux-watch'
import type { QueryClient } from '@tanstack/react-query'

import type { AppStore } from 'src/client/store'
import { clearSavedCheckoutReduxFormState } from 'storage/checkout'
import { removeAuthedQueries } from 'tripPlanner/hooks/api/common'
import { CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION } from 'actions/actionConstants'
import { CLEAR_SITE_BANNER } from 'actions/apiActionConstants'

export function watchAccount(store: AppStore, queryClient: QueryClient) {
  store.subscribe(watch(store.getState, 'auth.account')((account: App.AuthAccount) => {
    if (!account.memberId) {
      clearSavedCheckoutReduxFormState()
      removeAuthedQueries(queryClient)
      store.dispatch({ type: CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION })
      store.dispatch({ type: CLEAR_SITE_BANNER })
    }
  }))
}
